import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function RouteFocus() {
  const { pathname } = useLocation()

  useEffect(() => {
    const main = document.getElementById('main')
    if (main) {
      main.focus()
    }
  }, [pathname])

  return null
}
